import { Component, ChangeDetectorRef, OnInit } from '@angular/core';
import { firstValueFrom } from 'rxjs';
import { ApiService } from 'src/services/apiService';
import { Engineer, Governorate } from './engineer.interface';
import { jsPDF } from 'jspdf';
import html2canvas from 'html2canvas';
import * as ExcelJS from 'exceljs';
import * as FileSaver from 'file-saver';
import { AuthService } from 'src/services/auth.service';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-engineer-training',
  templateUrl: './engineer-training.component.html',
  styleUrls: ['./engineer-training.component.css']
})
export class EngineerTrainingComponent implements OnInit {

  currentYear: number = new Date().getFullYear();
  currentStep: number = 1;
  isStepDisabled: boolean = true;

  engineers: Engineer[] = [];
  filteredEngineers: Engineer[] = [];
  filteredEngineersRestFilter: Engineer[] = [];
  approvedEngineers: Engineer[] = [];

  governorates: Governorate[] = [
    { arName: 'العاصمة عمان', applicants: 0, number: 0, id: '', error: '', selectedEngineers: [] },
    { arName: 'اربد', applicants: 0, number: 0, id: '', error: '', selectedEngineers: [] },
    { arName: 'الزرقاء', applicants: 0, number: 0, id: '', error: '', selectedEngineers: [] },
    { arName: 'الكرك', applicants: 0, number: 0, id: '', error: '', selectedEngineers: [] },
    { arName: 'العقبة', applicants: 0, number: 0, id: '', error: '', selectedEngineers: [] },
    { arName: 'مادبا', applicants: 0, number: 0, id: '', error: '', selectedEngineers: [] },
    { arName: 'الطفيلة', applicants: 0, number: 0, id: '', error: '', selectedEngineers: [] },
    { arName: 'جرش', applicants: 0, number: 0, id: '', error: '', selectedEngineers: [] },
    { arName: 'معان', applicants: 0, number: 0, id: '', error: '', selectedEngineers: [] },
    { arName: 'البلقاء', applicants: 0, number: 0, id: '', error: '', selectedEngineers: [] },
    { arName: 'المفرق', applicants: 0, number: 0, id: '', error: '', selectedEngineers: [] },
    { arName: 'عجلون', applicants: 0, number: 0, id: '', error: '', selectedEngineers: [] }
  ];

  loading: boolean = false;
  showPopupZero: boolean = false;
  showPopup: boolean = false;
  showDataZero: boolean = false;
  showApprovedNumbers: boolean = false;
  showApprovedEngineers: boolean = true;
  showNotes: boolean = false;
  showSuccessMessage: boolean = false;

  sortedBy: keyof Engineer = 'name';
  isAscending: boolean = true;
  governorateFilter: string = '';
  dateFilter: string = '';

  openButton: boolean = true;
  isBackButtonDisabled: boolean = false;

  itemsPerPage: number = 10;
  currentPage: number = 1;
  totalPages: number = 0;
  HasNumberGreaterThanZero: number = 0;

  constructor(private apiService: ApiService, private cdr: ChangeDetectorRef,private authService:AuthService,private router: Router,private route: ActivatedRoute) { }

 async ngOnInit(): Promise<void> {
   await this.loadGovernorates();
}

  async loadGovernorates(): Promise<void> {
    try {

      const response = await firstValueFrom(this.apiService.get('MPWH/GetDirectorateInfo'));
      const data = response.data as any[];

      this.governorates.forEach(gov => {
        const match = data.find(d => d.arName === gov.arName);
        if (match) {
          gov.applicants = match.number || 0;
          gov.number = match.numberOfCertifiedEngineers || 0;
          gov.id = match.directorateId || '';
        }
      });

      const hasNumberGreaterThanZero = this.governorates.some(gov => gov.number > 0);
      this.HasNumberGreaterThanZero = this.governorates.reduce((sum, gov) => sum + (gov.applicants || 0), 0);;

      if (hasNumberGreaterThanZero) {
        this.isBackButtonDisabled = true;
        this.currentStep = 2;
      }

    } catch (error) {
      console.error('Error fetching governorates:', error);
      this.governorates.forEach(gov => gov.error = 'فشل في جلب البيانات');
    } finally {
      this.isStepDisabled = false;
      this.generateEngineers();
    }
  }


  async generateEngineers() {
    try {

      this.loading = true;
      const response = await firstValueFrom(this.apiService.get('MPWH/GetAllSumbitApplicationsByTrainerEngineersForCurrentYear'));
      const data = response.data as any[];
      this.filteredEngineers = [];

      this.governorates.forEach(gov => {
        if (gov.number > 0) {
          const matchedEngineers = data
            .filter(item => this.getGovernorateName(item.directorate) === gov.arName)
            .slice(0, gov.number)
            .map(item => ({
              name: item.name || 'غير متوفر',
              nationalId: item.nationalId || 'غير متوفر',
              certificateCountry: item.certificateCountry || 'غير متوفر',
              placeOfResidence: item.placeOfResidence || 'غير متوفر',
              phoneNumber: item.phoneNumber || 'غير متوفر',
              personalEmail: item.personalEmail || 'غير متوفر',
              applicationLocation: item.applicationLocation || 'غير متوفر',
              applicationNumber: item.applicationNumber || 'غير متوفر',
              directorate: gov.arName || 'غير متوفر', // هنا نأخذ اسم المحافظة مباشرة
              graduationDate: item.graduationDate || 'غير متوفر',
              department: item.department || 'غير متوفر',
              major: item.major || 'غير متوفر',
              gpa: item.gpa || 'غير متوفر',
              university: item.university || 'غير متوفر',
              membershipNo: item.membershipNo || 'غير متوفر'

            }));

          this.filteredEngineers.push(...matchedEngineers);
        }
      });
      this.filteredEngineersRestFilter = this.filteredEngineers;

      this.updatePagination();
    } catch (error) {
      console.error('Error fetching engineers:', error);
    } finally {
      this.loading = false;
      this.cdr.detectChanges();
    }
  }

  getGovernorateName(directorateId: string): string {
    const match = this.governorates.find(g => g.id === directorateId);
    return match ? match.arName : '';
  }


  goToStep(step: number): void {
    if (this.checkIfAllNumbersZero()) return;
    if (step === 2 && !this.isInvalid()) {
      this.isStepDisabled = false;
      this.currentStep = step;
      this.calculateEngineers();
    } else if (step === 1) {
      this.isStepDisabled = true;
      this.currentStep = step;
    }
  }

  checkIfAllNumbersZero(): boolean {
    const allZero = this.governorates.every(gov => gov.number === 0);
    if (allZero) {
      this.showPopupZero = true;
      this.currentStep = 1;
      return true;
    }
    this.generateEngineers();

    return false;
  }

  calculateEngineers(): void {
    this.filteredEngineers = [];

    this.governorates.forEach(gov => {
      if (gov.number > 0) {
        const engineersForGov = this.engineers
          .filter(engineer => engineer.directorate === gov.arName)
          .slice(0, gov.number); // يأخذ فقط العدد المحدد

        this.filteredEngineers.push(...engineersForGov);
      }
    });

    this.updatePagination();
  }

  filterData(): void {
    this.filteredEngineers = this.filteredEngineersRestFilter;
    if (this.governorateFilter) {
      this.filteredEngineers = this.filteredEngineers.filter(engineer => engineer.directorate === this.governorateFilter);
    } else {
      this.filteredEngineers = [...this.approvedEngineers];
    }
    this.currentPage = 1;
    this.updatePagination();
  }

  resetFilters(): void {
    this.governorateFilter = '';
    this.filteredEngineers = this.filteredEngineersRestFilter;
    this.updatePagination();
  }

  checkAndDownload(type: 'pdf' | 'excel'): void {
    if (!this.filteredEngineers || this.filteredEngineers.length === 0) {
      this.showDataZero = true; // لعرض الرسالة على واجهة المستخدم
      return;
    }

    if (type === 'pdf') {
      this.downloadPDF();
    } else if (type === 'excel') {
      this.downloadExcel();
    }
  }

  sortTable(column: keyof Engineer): void {
    if (this.sortedBy === column) {
      this.isAscending = !this.isAscending;
    } else {
      this.sortedBy = column;
      this.isAscending = true;
    }

    this.filteredEngineers.sort((a, b) => {
      const valueA = a[column]?.toString().toLowerCase() ?? '';
      const valueB = b[column]?.toString().toLowerCase() ?? '';

      if (valueA < valueB) return this.isAscending ? -1 : 1;
      if (valueA > valueB) return this.isAscending ? 1 : -1;
      return 0;
    });

    this.currentPage = 1;
    this.updatePagination();
  }



  updatePagination() {
    this.totalPages = Math.ceil(this.filteredEngineers.length / this.itemsPerPage);
  }

  changePage(page: number) {
    if (page < 1 || page > this.totalPages) return;
    this.currentPage = page;
  }

  get paginatedEngineers() {
    const startIndex = (this.currentPage - 1) * this.itemsPerPage;
    return this.filteredEngineers.slice(startIndex, startIndex + this.itemsPerPage);
  }

  downloadPDF() {
    const printContainer = document.getElementById('print-container');
    if (!printContainer) return;

    printContainer.style.display = 'block';

    setTimeout(() => {
      html2canvas(printContainer as HTMLElement, { scale: 2 }).then(canvas => {
        const imgData = canvas.toDataURL('image/png');
        const pdf = new jsPDF('p', 'mm', 'a4');
        const imgProps = pdf.getImageProperties(imgData);
        const pdfWidth = pdf.internal.pageSize.getWidth();
        const pdfHeight = (imgProps.height * pdfWidth) / imgProps.width;

        pdf.addImage(imgData, 'PNG', 0, 0, pdfWidth, pdfHeight);
        pdf.save('قائمة_المهندسين.pdf');

        printContainer.style.display = 'none';
      });
    }, 100);
  }

  previousPage(): void {
    if (this.currentPage > 1) {
      this.currentPage--;
    }
  }

  nextPage(): void {
    if (this.currentPage < this.totalPages) {
      this.currentPage++;
    }
  }

  getBorderClass(gov: Governorate): string {
    return gov.error ? 'invalid-input' : '';
  }

  checkValidInput(gov: Governorate): void {
    if (gov.number > gov.applicants) {
      this.openButton = false;
      gov.error = `العدد المدخل لا يمكن أن يتجاوز ${gov.applicants}`;
    } else {
      this.openButton = true;
      gov.error = '';
    }

    this.validateTotalInput();
  }

  async downloadExcel(): Promise<void> {
    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet('Engineers');

    const currentYear = new Date().getFullYear();
    const title = `قائمة المهندسين المعتمدين لسنة ${currentYear}`;
    const footerText = "Sultan Qandil - 00962799394551 - Sultan.Qandil@modee.gov.jo";

    worksheet.mergeCells('A1:H1');
    const titleCell = worksheet.getCell('A1');
    titleCell.value = title;
    titleCell.alignment = { horizontal: 'center', vertical: 'middle' };
    titleCell.font = { bold: true, color: { argb: 'FFFFFFFF' }, size: 14 };
    titleCell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: '4472C4' } };

    const headers = [
      'الاسم',
      'الرقم الوطني',
      'مكان الإقامة',
      'مكان التقديم',
      'رقم الهاتف',
      'الإيميل',
      'رقم الطلب',
      'الشهادة',
    ];
    worksheet.addRow(headers);

    headers.forEach((_, i) => {
      const cell = worksheet.getRow(2).getCell(i + 1);
      cell.font = { bold: true, color: { argb: 'FFFFFFFF' } };
      cell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: '4472C4' } };
      cell.alignment = { horizontal: 'center', vertical: 'middle' };
    });

    // ✅ هنا نستخدم filteredEngineers مباشرة
    this.filteredEngineers.forEach(engineer => {
      worksheet.addRow([
        engineer.name,
        engineer.nationalId,
        engineer.placeOfResidence,
        engineer.applicationLocation,
        engineer.phoneNumber,
        engineer.personalEmail,
        engineer.applicationNumber,
        engineer.certificateCountry
      ]);
    });

    for (let i = 3; i <= worksheet.lastRow!.number; i++) {
      const row = worksheet.getRow(i);
      row.eachCell((cell: any) => {
        cell.alignment = { horizontal: 'center', vertical: 'middle' };
        cell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'DAE3F3' } };
      });
    }

    const footerRow = worksheet.addRow([footerText]);
    worksheet.mergeCells(`A${footerRow.number}:H${footerRow.number}`);
    const footerCell = worksheet.getCell(`A${footerRow.number}`);
    footerCell.font = { bold: true, color: { argb: 'FFFFFFFF' } };
    footerCell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: '4472C4' } };
    footerCell.alignment = { horizontal: 'center', vertical: 'middle' };

    worksheet.columns = headers.map(() => ({ width: 25 }));

    const buffer = await workbook.xlsx.writeBuffer();
    const blob = new Blob([buffer], {
      type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    });
    FileSaver.saveAs(blob, `engineers-data-${currentYear}.xlsx`);
  }



  validateTotalInput(): void {
    const totalInput = this.governorates.reduce((sum, gov) => sum + (gov.number || 0), 0);
    if (totalInput > this.filteredEngineers.length) {
      this.openButton = true;
    }
  }

  changePageSize(size: number) {
    this.itemsPerPage = size;
    this.currentPage = 1;
    this.updatePagination();
  }

  isInvalid(): boolean {
    return this.governorates.some(gov => gov.number > gov.applicants);
  }

  cancelPopup() {
    this.showPopup = false;
    this.showPopupZero = false;
    this.showDataZero = false;
    this.showSuccessMessage = false;

  }

  toggleNotes() {
    this.showNotes = !this.showNotes;
  }

  async updateGovernoratesNumbers(): Promise<void> {
    this.disableBackButton();
    this.hidePopup();
    try {
      if (this.areAllGovernoratesNumbersZero()) {
        this.handleAllNumbersZero();
        return;
      }

      const payload = this.buildUpdatePayload();
      await firstValueFrom(
        this.apiService.post('MPWH/UpdateData', { payload })
      );
      this.showSuccessMessage = true;

      console.log('✅ تم تحديث أرقام المحافظات بنجاح');
    } catch (error) {
      this.handleUpdateError(error);
    }
  }

  private disableBackButton(): void {
    this.isBackButtonDisabled = true;
  }

  private hidePopup(): void {
    this.showPopup = false;
  }

  private areAllGovernoratesNumbersZero(): boolean {
    return this.governorates.every(gov => gov.number === 0);
  }

  private handleAllNumbersZero(): void {
    this.showPopupZero = true;
    this.currentStep = 1;
    console.warn('⚠️ جميع الأرقام صفر، لن يتم إرسال البيانات.');
  }

  private buildUpdatePayload(): { directorateId: string; number: number }[] {
    return this.governorates
      .filter(gov => gov.id)
      .map(gov => ({
        directorateId: gov.id,
        number: gov.number ?? 0
      }));
  }

  private handleUpdateError(error: any): void {
    console.error('❌ فشل في تحديث أرقام المحافظات:', error);
    this.governorates.forEach(gov => gov.error = 'فشل في تحديث البيانات');
  }


}